module.exports = __webpack_public_path__ + "img/active-past6.0cc786c7.jpg";